import React, { useState } from 'react';
import { Cookies, getCookieConsentValue } from "react-cookie-consent";
import { COOKIE_EXPIRATION, CONSENT_COOKIE, ANALYTICS_COOKIE } from "../store/config";
import { grantAnalyticsConsent, revokeAnalyticsConsent, markConsentVersion } from "../store/helpers/trackingConsent";
import { initGA } from "../index";
import { cookieRegistry, cookieCategoryLabel } from "../store/cookieRegistry";
// components
import { Divider, Header, Checkbox, Button, Form, Table } from 'semantic-ui-react';

const CookieSettings = ({ onClose }) => {
    const APAnalytics = getCookieConsentValue(ANALYTICS_COOKIE)

    const [allowAnalytics, setAllowAnalytics] = useState(String(APAnalytics) === "true" ? true : false)

    const handleConfirm = () => {
        if (allowAnalytics) {
            grantAnalyticsConsent()
            initGA()
        } else {
            Cookies.set(CONSENT_COOKIE, 'true', { expires: COOKIE_EXPIRATION })
            markConsentVersion()
            if (String(APAnalytics) === "true") {
                revokeAnalyticsConsent()
            }
        }
        if (onClose) onClose()
    }

    return (
        <div style={{ fontFamily: "Metropolis Regular" }}>
            <Header as="h3" content={"Nastavenie cookies"}/>

            <p>
                Súbory cookie používame na fungovanie webu a na analýzu správania návštevníkov, aby sme mohli zlepšovať naše služby. Okrem nástrojov tretích strán (Google Analytics, Facebook Pixel) využívame aj vlastnú analytiku ActivityPoint, ktorá meria anonymne používanie vyhľadávania a detailov aktivít. Neukladáme mená, e-maily, IP adresy ani presnú polohu.
            </p>

            <Divider/>

            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", marginBottom: "2rem" }}>
                <p style={{ margin: 0, fontWeight: "bold" }}>
                    Nevyhnutné súbory cookies
                </p>
                <Checkbox toggle disabled checked={true}/>
            </div>
            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", marginBottom: "2rem" }}>
                <p style={{ margin: 0, fontWeight: "bold" }}>
                    Analytické/výkonnostné súbory cookies
                </p>
                <Checkbox toggle
                    checked={allowAnalytics}
                    onChange={() => setAllowAnalytics(!allowAnalytics)}
                />
            </div>

            <Table celled unstackable size="small">
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>Názov</Table.HeaderCell>
                        <Table.HeaderCell>Kategória</Table.HeaderCell>
                        <Table.HeaderCell>Platnosť</Table.HeaderCell>
                        <Table.HeaderCell>Účel</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {cookieRegistry.map((cookie) => (
                        <Table.Row key={cookie.name}>
                            <Table.Cell><strong>{cookie.name}</strong></Table.Cell>
                            <Table.Cell>{cookieCategoryLabel[cookie.category]}</Table.Cell>
                            <Table.Cell>{cookie.expiration}</Table.Cell>
                            <Table.Cell>
                                {cookie.purpose}
                                {cookie.thirdParty && <em> (vrátane nástrojov tretích strán)</em>}
                            </Table.Cell>
                        </Table.Row>
                    ))}
                </Table.Body>
            </Table>

            <Form.Field style={{ textAlign: "right" }}>
                <Button
                    type="button"
                    content={"Potvrdiť"}
                    style={{ background: "var(--primary)", color: "var(--white)" }}
                    onClick={handleConfirm}
                />
            </Form.Field>
        </div>
    );
};

export default CookieSettings;
